import type { ComponentProps } from 'react';
import { cn } from '../../lib/cn';

export function Table({ className, ...props }: ComponentProps<'table'>) {
  return (
    <div className="w-full overflow-x-auto">
      <table className={cn('w-full text-sm', className)} {...props} />
    </div>
  );
}

export const THead = (props: ComponentProps<'thead'>) => (
  <thead className="bg-muted/70" {...props} />
);
export const TBody = (props: ComponentProps<'tbody'>) => (
  <tbody className="divide-y divide-border" {...props} />
);
export const TR = ({ className, ...props }: ComponentProps<'tr'>) => (
  <tr className={cn('hover:bg-muted/40', className)} {...props} />
);
export const TH = ({ className, ...props }: ComponentProps<'th'>) => (
  <th
    scope="col"
    className={cn(
      'px-4 py-2.5 text-start text-xs font-semibold tracking-wide text-muted-foreground uppercase',
      className,
    )}
    {...props}
  />
);
export const TD = ({ className, ...props }: ComponentProps<'td'>) => (
  <td className={cn('px-4 py-2.5 align-top', className)} {...props} />
);
